module.exports = __webpack_public_path__ + "img/faq1.6b90413a.png";